import React, { useState, useContext, useMemo, useEffect } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledModalPrecificacao } from "../../styled-components/StyledModalPrecificacao.style";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import api from '../../services/api';
import Swal from "sweetalert2";
import IntlCurrencyInput from "react-intl-currency-input"
import { StldInput } from '../../styled-components/StyledInput.style';
import { StldRadioOptions } from '../../styled-components/StyledRadioOptions.style';
import Select from 'react-select';
import { NumericFormat } from 'react-number-format';

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

export const ModalConfigurarDesconto = ({ timesheetDescontoComercial, isOpen, onAfterOpen, onRequestClose, loadPage, peritos }) => {
    const { timesheet } = useContext(TimeSheetDetalhesContext);

    useEffect(() => {
        if(timesheetDescontoComercial != null) {
            timesheetDescontoComercial.tipoDescontoComercial = tiposDeDesconto.filter(tipo => tipo.value == timesheetDescontoComercial.idTipoDescontoComercial)[0]
            setDesconto(timesheetDescontoComercial)
        }
    }, [timesheetDescontoComercial]);

    const tiposDeDesconto = useMemo(() => [
        {
            "value": 1,
            "id": "Desconto concedido pela diretoria",
            "label": "Desconto concedido pela diretoria"
        },
        {
            "value": 2,
            "id": "Desconto negociado cliente",
            "label": "Desconto negociado cliente"
        }
    ], []);

    const [desconto, setDesconto] = useState({
        idTimesheet: null,
        idTipoDescontoComercial: null,
        tipoDescontoComercial: null,
        isPorcentagem: null,
        desconto: 0,
        observacao: ""
    });

    const [isLoading, setisLoading] = useState(false);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '50%',
            overflowY: 'auto',
            minHeight: '70%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const registrationSuccess = (text = "Configuração de desconto realizado com sucesso!") => {
        Swal.fire({
            title: "Sucesso",
            text: text,
            icon: "success",
            timer: 2500,
            showConfirmButton: false,
        });
    };

    const registrationFailure = (text = "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    };

    const formActivities = async () => {
        if(desconto.tipoDescontoComercial == null) {
            registrationFailure("Necessário selecionar o Tipo de Desconto!")
            return
        }
        var payload = {
            idTimesheet: timesheet?.timesheet?.idTimesheet,
            idTipoDescontoComercial: desconto.tipoDescontoComercial.value,
            tipoDescontoComercial: desconto.tipoDescontoComercial,
            isPorcentagem: desconto.isPorcentagem,
            desconto: desconto.desconto,
            observacao: desconto.observacao || ""
        }
        setisLoading(true)
        await api.put('TimesheetDescontoComercial', payload)
            .then(async (response) => {
                onRequestClose(false);
                setisLoading(false)
                registrationSuccess();
                loadPage();
            })
            .catch((error) => {
                setisLoading(false)
                registrationFailure(error?.response?.data?.notification?.messageReturn)
            });
    }

    const removeDesconto = async () => {
        setisLoading(true)
        await api.delete(`TimesheetDescontoComercial/${desconto?.idTimesheet}`)
            .then(async (response) => {
                onRequestClose(false);
                setisLoading(false)
                setDesconto({
                    idTimesheet: null,
                    idTipoDescontoComercial: null,
                    tipoDescontoComercial: null,
                    isPorcentagem: null,
                    desconto: 0,
                    observacao: ""
                });
                registrationSuccess("Desconto removido com sucesso!");
                loadPage();
            })
            .catch((error) => {
                setisLoading(false)
                registrationFailure(error?.response?.data?.notification?.messageReturn)
            });
    }

    const typeOptions = [
        { value: true, name: "tipo", label: "Porcentagem" },
        { value: false, name: "tipo", label: "Valor Desconto" }
    ];

    const setTipoConfiguracao = (tipo) => {
        desconto.isPorcentagem = tipo.label == "Porcentagem"
        desconto.desconto = 0
        setDesconto({...desconto})
    }
    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Precificação"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledModalPrecificacao>
                <StyledForm>
                    <p className="modal-close" onClick={onRequestClose}>X</p>
                </StyledForm>
                <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Configurar Desconto</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    {isLoading ? (
                        <div className="text-center">
                            <div className="align-items-center">
                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <Flex>
                                <StldRadioOptions>
                                    {typeOptions.map((option, index) => {
                                        return (
                                            <div key={index} className="mr-4 hover" onClick={() => setTipoConfiguracao(option)}>
                                                <input
                                                    type="radio"
                                                    value={option.value}
                                                    name={option.name}
                                                    defaultValue={desconto.isPorcentagem}
                                                    checked={
                                                        (option.label == "Porcentagem" && desconto.isPorcentagem != null && desconto.isPorcentagem) ||
                                                        (option.label == "Valor Desconto" && desconto.isPorcentagem != null && !desconto.isPorcentagem)
                                                    }
                                                    className="mr-2" />
                                                {option.label}
                                            </div>
                                        )
                                    })}
                                </StldRadioOptions>
                            </Flex>
                            {
                                desconto.isPorcentagem != null && (
                                    <>
                                        <Flex.Item style={{ width: '100%' }}>
                                            <div className="position-relative form-group">
                                                <Select
                                                    className="basic-single"
                                                    placeholder={'Tipo do Desconto'}
                                                    options={tiposDeDesconto}
                                                    defaultValue={desconto.tipoDescontoComercial}
                                                    onChange={(descontoSel) => {
                                                        desconto.idTipoDescontoComercial = descontoSel.value
                                                        desconto.tipoDescontoComercial = descontoSel
                                                        setDesconto({...desconto})
                                                    }}
                                                />
                                            </div>
                                        </Flex.Item>
                                        <Flex.Item style={{ width: '100%' }}>
                                            <div className="position-relative form-group">
                                                <StldInput>
                                                    <label className="focused">Valor</label>
                                                    {
                                                      desconto.isPorcentagem && (
                                                        <NumericFormat
                                                          suffix={' %'}
                                                          decimalScale={2}
                                                          value={desconto.desconto}
                                                          thousandSeparator={false}
                                                          onValueChange={(value) => {
                                                            desconto.desconto = value.floatValue
                                                            setDesconto({...desconto})
                                                          }}
                                                        />
                                                      )
                                                    }

                                                    {
                                                      !desconto.isPorcentagem && (
                                                        <IntlCurrencyInput
                                                          currency="BRL"
                                                          config={currencyConfig}
                                                          defaultValue={desconto.desconto}
                                                          onChange={(_event, value, _maskedValue) => {
                                                              desconto.desconto = value
                                                              setDesconto({...desconto})
                                                          }}
                                                        />
                                                      )
                                                    }
                                                </StldInput>
                                            </div>
                                        </Flex.Item>
                                        <Flex.Item style={{ width: '100%' }}>
                                            <div className="position-relative form-group">
                                                <StldInput>
                                                    <label className="focused">Observação</label>
                                                    <textarea
                                                        rows="3"
                                                        className="input-form-list"
                                                        style={{ width: '100%' }}
                                                        name="Observação"
                                                        placeholder="Digite aqui"
                                                        defaultValue={desconto.observacao}
                                                        onBlur={(event) => {
                                                            desconto.observacao = event.target.value
                                                            setDesconto({...desconto})
                                                        }}
                                                    />
                                                </StldInput>
                                            </div>
                                        </Flex.Item>
                                        <Flex>
                                            <Flex.Item className="modal-width">
                                                <div className="position-relative form-group modal-align-center">
                                                    <input className='default-button-red' value='Salvar' type="button" onClick={formActivities} />
                                                    {
                                                        desconto?.idTimesheet != null && <input className='default-button-red button-resumo ml-3' value='Remover' type="button" onClick={removeDesconto} />
                                                    }
                                                    
                                                </div>
                                            </Flex.Item>
                                        </Flex>
                                    </>
                                )
                            }
                        </div>
                    )}
                </StyledForm>
            </StyledModalPrecificacao>
        </Modal>
    );
};